<template>
    <div>
        <v-navigation-drawer
            v-model="mobileDrawer"
            :light="!$vuetify.theme.dark"
            :dark="$vuetify.theme.dark"
            app
            left
            temporary
            disable-route-watcher
            style="transition: 0.25s; z-index: 998"
            class="pa-2"
        >
            <div
                :class="{
                    mobileTabs: $breakpoint.smAndDown,
                    'pt-4': $auth.loggedIn
                }"
            >
                <div
                    v-if="!$auth.loggedIn"
                    style="position: absolute; right: 0; z-index: 9"
                >
                    <v-btn
                        outlined
                        border-none
                        style="border: none; color: white"
                        :class="{
                            'd-none': $breakpoint.mdAndUp
                        }"
                        @click="mobileDrawer = !mobileDrawer"
                    >
                        <v-icon size="18">mdi-close </v-icon>
                    </v-btn>
                </div>
                <v-list-item
                    v-if="$auth.loggedIn"
                    :color="$vuetify.theme.dark ? 'white' : 'black'"
                >
                    <v-list-item-content>
                        <v-list-item-title
                            class="uname d-flex align-items-center justify-content-start white--text text-capitalize"
                        >
                            <span
                                ><img
                                    width="40"
                                    height="40"
                                    class="mr-4 rounded-circle w-15 d-inline-block"
                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSa69_HGc_i3MXKCPZzCfAjBZC4bXJsn0rS0Ufe6H-ctZz5FbIVaPkd1jCPTpKwPruIT3Q&usqp=CAU"
                            /></span>
                            <span> {{ $auth.user.username }}</span>
                            <div style="position: absolute; right: 0">
                                <v-btn
                                    outlined
                                    border-none
                                    style="border: none; color: white"
                                    :class="{
                                        'd-none': $breakpoint.mdAndUp
                                    }"
                                    @click="mobileDrawer = !mobileDrawer"
                                >
                                    <v-icon size="18">mdi-close </v-icon>
                                </v-btn>
                            </div>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <div v-if="$auth.loggedIn" class="px-4 py-0">
                    <hr
                        class="v-divider primary"
                        :class="
                            $vuetify.theme.dark ? 'theme--dark' : 'theme--light'
                        "
                    />
                </div>
                <sportsbook-category
                    :orientation="'vertical'"
                ></sportsbook-category>
                <!-- <favorites></favorites> -->
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
import SportsbookCategory from "@/components/sections/SportsbookCategory"
// import Favorites from '@/components/Favorites'

export default {
    components: {
        SportsbookCategory
        // Favorites
    },
    data() {
        return {}
    },

    computed: {
        mobileDrawer: {
            get() {
                return this.$store.getters["mobileDrawer/value"]
            },
            set(v) {
                return this.$store.commit("mobileDrawer/toggle", v)
            }
        }
    },
    created() {},
    methods: {}
}
</script>
